import { Menu, ActionIcon, Stack, Tooltip } from '@mantine/core';

import { useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { CheckIcon, ChevronDown } from '../../icons';
import { updateResourceAssistantState } from '../../redux/ResourceAssistantSlice';
import { selectResourceAssistantState } from '../../redux/store';

interface Props {
  disabled: boolean
  iconColor: string
}

const QueryResourcesSelector: React.FC<Props> = (props: Props) => {
  const { disabled, iconColor } = props;

  const [opened, setOpened] = useState(false);
  const dispatch = useDispatch();

  const { filterByProposal } = useSelector(selectResourceAssistantState);

  const handleEditFilterByProposal = useCallback((filterByProposal: boolean) => {
    dispatch(updateResourceAssistantState({
      filterByProposal
    }));
  }, []);

  return (
    <Menu
      position="top-end"
      offset={10}
      opened={opened}
      onChange={setOpened}
    >
      <Menu.Target>
        <Tooltip
          label='Query options'
          position='top'
          withArrow
        >
          <ActionIcon
            onClick={() => { setOpened((o) => !o); }}
            size='sm'
            bg='transparent'
            radius='4px'
            disabled={disabled}
          >
            <ChevronDown color={iconColor} />
          </ActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown maw={300}>
        <Stack gap={0}>
          <Menu.Item
            onClick={() => { handleEditFilterByProposal(false); setOpened(false); }}
            leftSection={!filterByProposal && <CheckIcon />}
          >
            All resources
          </Menu.Item>
          <Menu.Item
            leftSection={filterByProposal && <CheckIcon />}
            onClick={() => { handleEditFilterByProposal(true); setOpened(false); }}
          >
            Proposal specific resources
          </Menu.Item>
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
};

export default QueryResourcesSelector;
